const youTubeConsentLabels = {
    de: {
        title: 'YouTube Video laden',
        reject: 'ablehnen',
        confirm: 'Video laden',
        infoText: 'An dieser Stelle laden wir ein externes Video von YouTube.<br>Dabei werden Daten mit den YouTube Servern ausgetauscht.<br>Weitere Infos dazu finden Sie in den <a href="https://policies.google.com/technologies/cookies?hl=de" target="_blank" rel="noopener">Datenschutzbedingungen</a> von YouTube/Google.'
    },
    en: {
        title: 'YouTube video loading',
        reject: 'reject',
        confirm: 'load video',
        infoText: 'An external video will be loaded from YouTube.<br>This includes in user data beeing sent to the YouTube server.<br>More info at <a href="https://policies.google.com/technologies/cookies?hl=en" target="_blank" rel="noopener">privacy policy</a> at YouTube/Google.'
    },
    es: {
        title: 'Cargar vídeo de YouTube',
        reject: 'rechazar',
        confirm: 'cargar video',
        infoText: 'En este punto cargamos un vídeo externo de YouTube.<br>En el proceso, se intercambian datos con los servidores de YouTube.<br>Para más información, consulte <a href="https://policies.google.com/technologies/cookies?hl=es" target="_blank" rel="noopener">la política de privacidad</a> de YouTube/Google.'
    }
}

export default youTubeConsentLabels;
